module.exports = __webpack_public_path__ + "static/media/warning.209dd6f9.svg";